export default __webpack_public_path__ + "static/media/ud_bookmark.f0ac3086.svg";